import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InsuranceCoveragePackage  {
    _originalTypeClassName = "zERP.BO.InsuranceCoveragePackage";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InsuranceCoveragePackage.translate = translateService;
}
this.Versions = [];
this.Professions = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.SystemOwner = null;
this.FullName = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
SystemOwner:any;
FullName:any;
Description:any;
Versions:any;
Professions:any;
static setVersions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Versions == null) $this.Versions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Versions.length > 0) {
                    Domain.InsuranceCoveragePackage.removeVersions($this, $this.Versions[0]);
                }

                Domain.InsuranceCoveragePackage.addManyVersions($this, copyItems);
            }
static addManyVersions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InsuranceCoveragePackage.addVersions($this, items[i]);
                }
            }
static addVersions = ($this, item) => {
                if ($this.Versions == null) $this.Versions = [];
                if (item == null || $this.Versions.indexOf(item) > -1) return;
                $this.Versions.push(item);
}
static addRangeVersions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InsuranceCoveragePackage.addVersions($this, item));
            }
static removeVersions = ($this, item) => {
                if ($this == null || $this.Versions == null || $this.Versions.indexOf(item) === -1) return;
                var _index = $this.Versions.indexOf(item);
                $this.Versions.splice(_index, 1);
}
static clearVersions = ($this) => { $this.Versions = null; }
static setProfessions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Professions == null) $this.Professions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Professions.length > 0) {
                    Domain.InsuranceCoveragePackage.removeProfessions($this, $this.Professions[0]);
                }

                Domain.InsuranceCoveragePackage.addManyProfessions($this, copyItems);
            }
static addManyProfessions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InsuranceCoveragePackage.addProfessions($this, items[i]);
                }
            }
static addProfessions = ($this, item) => {
                if ($this.Professions == null) $this.Professions = [];
                if (item == null || $this.Professions.indexOf(item) > -1) return;
                $this.Professions.push(item);
if (item.InsuranceCoveragePackage != $this) {
Domain.SICProfessionPackage.setInsuranceCoveragePackage(item, $this);
}
}
static addRangeProfessions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InsuranceCoveragePackage.addProfessions($this, item));
            }
static removeProfessions = ($this, item) => {
                if ($this == null || $this.Professions == null || $this.Professions.indexOf(item) === -1) return;
                var _index = $this.Professions.indexOf(item);
                $this.Professions.splice(_index, 1);
item.InsuranceCoveragePackage = null;
}
static clearProfessions = ($this) => { $this.Professions = null; }

static GetFullName($this: any): any{return $this?.Code + " - " + $this?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}